import { AiseaApiFactory } from "@/api/aisea/apiFactory";

// 配乗スコアリングカテゴリーマスター
const enterpriseAssignmentScoringCategoriesRepository = AiseaApiFactory.get(
  "enterpriseAssignmentScoringCategories"
);

/**
 * 配乗スコアリングカテゴリーマスターサービス
 */
const EnterpriseAssignmentScoringCategoriesService = (() => {
  let _enterpriseAssignmentScoringCategories = null;

  const fetch = async () => {
    const payload = {
      details: ["ITEM"],
    };
    const res = await enterpriseAssignmentScoringCategoriesRepository.fetch(
      payload
    );
    if (!res || !res.status) {
      throw res;
    }

    _enterpriseAssignmentScoringCategories = res.data;
    return _enterpriseAssignmentScoringCategories;
  };

  const clear = () => {
    _enterpriseAssignmentScoringCategories = null;
  };

  /**
   * スコアカテゴリーをIDで検索します。
   * @param {*} category_id
   * @returns
   */
  const findCategoryById = category_id => {
    if (!_enterpriseAssignmentScoringCategories) {
      return null;
    }

    return (
      _enterpriseAssignmentScoringCategories.crew_assignment_scoring_categories.find(
        category => category.id === category_id
      ) || null
    );
  };

  /**
   * スコアカテゴリー内のアイテムをIDで検索します。
   * @param {*} category_id
   * @param {*} item_id
   * @returns
   */
  const findCategoryItemById = (category_id, item_id) => {
    const category = findCategoryById(category_id);
    if (!category) {
      return null;
    }

    return (
      category.crew_assignment_scoring_category_item.find(
        item => item.id === item_id
      ) || null
    );
  };

  return {
    fetch,
    clear,
    findCategoryById,
    findCategoryItemById,
  };
})();

export default EnterpriseAssignmentScoringCategoriesService;
